export enum SubmittalStatusRequestors {
    StaffRecruiting = 1,
    AccountManagersLiveList = 2
}
